<template>
  <slot v-if="!!user" />
</template>
<script lang="ts" setup>
const user = useSupabaseUser();
</script>
